import { useState, useEffect, useRef } from 'react';
import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import { useNavigate } from 'react-router-dom';
import imgLogo from './Portal_PWC.png';
import rightLogo from './right_bar.jpg';
import axios from 'axios';
import { useAuth } from 'oidc-react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import validator from "validator";

function ConfirmMutilation() {
  const auth = useAuth();
  const [configJsonFile, setConfigJsonFile] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/Config.json`);
        const data = await response.json();
        setConfigJsonFile(data);
        console.log("Json file read from the Public folder completed:");
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (configJsonFile != "undefined") {
      //getCSRFToken();
    }
  }, [configJsonFile]);

  const navigate = useNavigate();
  const [modelPopupshow, setmodelPopupshow] = useState(false);
  const [apimessage, setAPIMessage] = useState('');
  const [VendorCode, setVendorCode] = useState("");
  const [VendorEmail, setVendorEmail] = useState("");
  const [comments, setComments] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [TicketNumber, setTicketNumber] = useState("");
  const [OtherComments, setOtherComments] = useState("");
  const [showOtherCommentsText, setShowOtherCommentsText] = useState(false);
  const [isConfirmChecked, setIsConfirmChecked] = useState(false);
  const csrfToken = useRef(null);
  const cookieToken = useRef(null);
  const [InitiatorEmailAddress, setInitiatorEmailAddress] = useState("");
  const [initiatorEmailError, setInitiatorEmailError] = useState("");
  const [vendorEmailError, setVendorEmailError] = useState("");
  const [VendorEmailCc, setVendorEmailCc] = useState("");
  const [vendorEmailCcError, setVendorEmailCcError] = useState("");
  const [apiErrormessage, setApiErrormessage] = useState("");
  const [invalidTicketID, setInvalidTicketID] = useState("");
  const [loading, setLoading] = useState(false);


  let storedValue = localStorage.getItem("ScrapProcessID");
  let autoIncrementVal = "";
  let newProcessIDNum = "";

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    return `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
  }

  const getCSRFToken = async () => {
    var resTokenApiVal = auth.userData.access_token;
    console.log("acceesToken: " + resTokenApiVal);
    console.log("ConfigFileServerAPI URL: " + configJsonFile.ServerAPIUrl);
    await axios.get(configJsonFile.ServerAPIUrl, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-id': configJsonFile.ClientId,
        'Authorization': "Bearer " + resTokenApiVal
      }
    }).then(res => {
      console.log(res);
      csrfToken.current = res.data.requestToken;
      cookieToken.current = res.data.cookieToken;
    })
  }

  // Form submit 
  const handleSubmit = async (event) => {
    if (validator.isEmail(VendorEmail)) {
      var isSelectedCheckbox = isCheckboxSelected();
      if (Object.keys(checkedItems).length === 0 || !isSelectedCheckbox) {
        alert('Please select at least one checkbox from "How were the part(s) mutilated" section to continue');
        event.preventDefault();
      }
      else {
        const isSubmitConfirm = window.confirm('Are you sure you want to Confirm Mutilation?');
        if (isSubmitConfirm) {
          event.preventDefault();
          setLoading(true);
          let CurrentYear = getCurrentDateTime();
          if (storedValue == null) {
            storedValue = 1;
          }
          //console.log("Auth data:"+auth);      
          var resTokenApiVal = auth.userData.access_token;
          newProcessIDNum = Number(storedValue) + 1;
          if (storedValue === 1) {
            autoIncrementVal = String(storedValue).padStart(3, 0);
          }
          else {
            autoIncrementVal = String(newProcessIDNum).padStart(3, 0);
          }
          var ObjPart = "";
          var isOtherCheckBoxSelected = "";
          for (var key in checkedItems) {
            var PartIDNum = getIDMutilated(key);
            if (PartIDNum === 9) {
              isOtherCheckBoxSelected = "Yes";
            } else {
              ObjPart = ObjPart + PartIDNum + "#" + key + "|;";
            }
          }
          if (isOtherCheckBoxSelected === "Yes") {
            ObjPart = ObjPart + "__Other__#" + OtherComments;
          } else {
            ObjPart = ObjPart.slice(0, -2);
          }


          // Create JSON File
          var data = {
            ProcessInfo: {
              domainId: "supplyMangnt",
              ProcessId: configJsonFile.ConfirmMutilationProcessId,
              NewRequest: false,
              InstanceNumber: TicketNumber,
              AttachmentID: "Att_" + configJsonFile.ConfirmMutilationProcessId + "_" + CurrentYear + "_" + autoIncrementVal + "_" + TicketNumber,
              PathID: configJsonFile.ConfirmMutilationPathID,
              workflowID: configJsonFile.ScrapGuids.WorkflowGuid,
              businessEntity: configJsonFile.ScrapGuids.BusinessEntityGuid,
              dbId: configJsonFile.ScrapGuids.dbId,
              formTypeId: configJsonFile.ScrapGuids.formTypeId,
              BaseBPSPortalAddress: configJsonFile.BaseBPSPortalAddress,
              WebconClientId: configJsonFile.WebconClientId,
              WebconclientSecret: configJsonFile.WebconclientSecret,
              WebconTokenURL: configJsonFile.WebconTokenURL
            },
            Form: [
              { GUID: configJsonFile.ScrapGuids.VendorCodeFromReact, sValue: VendorCode, name: "Vendor Code From React" },
              { GUID: configJsonFile.ScrapGuids.VendorEmailFromReact, sValue: VendorEmail, name: "Vendor Email From React" },
              { GUID: configJsonFile.ScrapGuids.HowPartWereMutilated, sValue: ObjPart, name: "How Part Were Mutilated" },
              { GUID: configJsonFile.ScrapGuids.Mutilation_Witness, sValue: comments, name: "Mutilation Witness" },              
              { GUID: configJsonFile.ScrapGuids.VendorEmail_Cc, sValue: VendorEmailCc, name: "VendorEmail_Cc" }
            ],
            GeneralInformation: [],
            GeneralInformationListGuids: {
              PartNumberGuid: "",
              ReasonForScrapGuid: "",
              QuantityGuid: "",
              PO_SA_NumberGuid: "",
              QN_RFA_NumberGuid: "",
              SerialNumberGuid: "",
              generalInfoItemListGuid: ""
            }
          };
          //alert(dictstring);
          console.log(data);
          CallWebAPI(data, resTokenApiVal);

          // Update Session variable to get increment num
          localStorage.setItem("ScrapProcessID", newProcessIDNum);
          // Call API End               
        }
      }
    }
    else {
      alert("Please enter valid email address!");
      event.preventDefault();
    }

  }
  function isCheckboxSelected() {
    if (Object.values(checkedItems).some(value => value === true)) {
      return true;
    }
    return false;
  }
  function getIDMutilated(MutilatedValue) {
    let PartIDNumber;
    if (MutilatedValue === "Grinding") {
      PartIDNumber = 1;
    }
    else if (MutilatedValue === "Burning") {
      PartIDNumber = 2;
    }
    else if (MutilatedValue === "Removal of a major integral feature") {
      PartIDNumber = 3;
    }
    else if (MutilatedValue === "Permanent distortion of parts") {
      PartIDNumber = 4;
    }
    else if (MutilatedValue === "Cutting a significant size hole with a cutting torch or saw") {
      PartIDNumber = 5;
    }
    else if (MutilatedValue === "Melting") {
      PartIDNumber = 6;
    }
    else if (MutilatedValue === "Sawing into many small pieces") {
      PartIDNumber = 7;
    }
    else if (MutilatedValue === "Removing manufacturer’s identification, part, lot, batch, and serial numbers") {
      PartIDNumber = 8;
    }
    else {
      PartIDNumber = 9;
    }
    return PartIDNumber;
  }

  // Call API to upload files to S3
  const CallWebAPI = async (requestBody, getTokeVal) => {
    try {

      console.log("Calling ServerAPI URL from Config public folder: " + configJsonFile.Server_Webcon_Creation_APIUrl);

      console.log("Cookie Toke:" + cookieToken.current);
      console.log("csrfToken:" + csrfToken.current);
      const parsedUrl = new URL(configJsonFile.Server_Webcon_Creation_APIUrl);
      if (!isValidDomain(parsedUrl.hostname)) {
        throw new Error('Invalid domain');
      }
      const axiosInstance = axios.create({
        baseURL: configJsonFile.ServerAPIUrl,
        allowAbsoluteUrls: false
        });
      axios.post(parsedUrl, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'x-api-id': configJsonFile.ClientId,
          'Authorization': "Bearer " + getTokeVal,
          'RequestVerificationToken': csrfToken.current
        }
      }).then(res => {
        if (res.status === 201 || res.status === 200 || res.status === 202) {

          var elementID = res.data;
          if (selectedFile.length > 0) {
            for (let i = 0; i < selectedFile.length; i++) {
              // upload each file to S3 calling API here
              let Num = i + 1;
              CallWebAPIUploadFileToS3(selectedFile[i], Num, getTokeVal, elementID);
            }
          }
          else{
            setLoading(false);
            setmodelPopupshow(true);          
            setApiErrormessage("");
          }
        } else {
          console.log("Status Code:" + res.status);
        }
      }).catch(error => {
        if (error.response) {
          console.log('Error response:', error.response.data);
          setLoading(false);
          setApiErrormessage(error.response.data || 'An error occurred');
         
          if (error.response.data.includes("Element does not exist") || error.response.data.includes("Access to the selected workflow instance is denied!")) 
          {
            setInvalidTicketID("Invalid");
            setApiErrormessage("TicketID '" + TicketNumber + "' does not exist, Please enter correct value and submit again.")
          } 
          else if (error.response.data.includes("Path is not available in current step"))
          {
            setApiErrormessage("Scrap form# " + TicketNumber + " is not yet at Mutilation Step, please wait for email notification to proceed.")
          }
          else 
          {
            setInvalidTicketID("");
          };
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
      });

    } catch (err) {
      console.log(err);
      setAPIMessage("Failed Due to:" + err);
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

  }

  const CallWebAPIUploadFileToS3 = async (requestBody, num, getTokeVal, elementID) => {
    try {
      let fileNameVal = elementID + "_" + num + "-" + requestBody.name;
      console.log("FileName: " + fileNameVal);
      const formData = new FormData();
      formData.append('file', requestBody);
      formData.append('fileName', fileNameVal);
      formData.append('processID', "");
      formData.append('cookie', cookieToken.current);

      axios.post(configJsonFile.Server_Upload_FilesToS3_APIUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-api-id': configJsonFile.ClientId,
          'Authorization': "Bearer " + getTokeVal
        }
      }).then(res => {
        if (res.status === 201 || res.status === 200 || res.status === 202) {
          setLoading(false);
          setmodelPopupshow(true);
          setAPIMessage("Files are uploaded successfully to AWS S3");
        } else {
          console.log("Status Code:" + res.status);
        }
      });

    } catch (err) {
      setLoading(false);
      setApiErrormessage(err.response.data || 'An error occurred');
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

  }

  const isValidDomain = (domain) => {
    const allowedDomains = ['apid.pwc.ca', 'apiq-ext.pwc.ca', 'api-ext.pwc.ca'];
    return allowedDomains.includes(domain);
  };

  const onClickHomeHandler = async (event) => {
    const isConfirmedHome = window.confirm('You might loose the data, Are you sure you want to go to home page?');
    if (isConfirmedHome) {
      navigate('/');
    }
  }
  const onClickCancelHandler = async (event) => {
    const isConfirmedCancel = window.confirm('You might loose the data, Are you sure you want to Cancel this request?');
    if (isConfirmedCancel) {
      navigate('/');
    }

  }

  //plain object as state

  const handleChange = (event) => {
    // updating an object instead of a Map
    setCheckedItems({ ...checkedItems, [event.target.name]: event.target.checked });
    if (event.target.name === "Other (mention below)") {
      if (event.target.checked) {
        setShowOtherCommentsText(true);
      } else {
        setShowOtherCommentsText(false);
      }

    }
  }

  const handleChangeConfirmCheckbox = () => {
    setIsConfirmChecked(!isConfirmChecked);
  }

  useEffect(() => {
    console.log("checkedItems: ", checkedItems);
  }, [checkedItems]);


  const checkboxes = [
    {
      name: 'Grinding',
      key: 'chckbox1',
      label: 'Grinding',
    },
    {
      name: 'Burning',
      key: 'chckbox2',
      label: 'Burning',
    },
    {
      name: 'Removal of a major integral feature',
      key: 'chckbox3',
      label: 'Burning',
    },
    {
      name: 'Permanent distortion of parts',
      key: '-chckbox4',
      label: 'Burning',
    },
    {
      name: 'Cutting a significant size hole with a cutting torch or saw',
      key: 'chckbox5',
      label: 'Burning',
    },
    {
      name: 'Melting',
      key: 'Burning',
      label: 'Burning',
    },
    {
      name: 'Sawing into many small pieces',
      key: 'chckbox6',
      label: 'Burning',
    },
    {
      name: 'Removing manufacturer’s identification, part, lot, batch, and serial numbers',
      key: 'chckbox7',
      label: 'Burning',
    },
    {
      name: 'Other (mention below)',
      key: 'chckbox8',
      label: 'Burning',
    }

  ];

  // const autoCloseModelPopupOnTimeout=()=>{
  //   // 10 seconds time out automatically close the model-popup and redirect to home page.
  //   setTimeout(function()
  //   {
  //     navigate('/');
  //   }, 14000);
  // }

  const handleOkButtonModelPopup = () => {
    navigate('/');
    setmodelPopupshow(false);
  }

  const validateInitiatorEmail = (e) => {
    const email = e.target.value;
    if (validator.isEmail(email)) {
      setInitiatorEmailAddress(e.target.value);
      setInitiatorEmailError("");
    } else {
      setInitiatorEmailAddress(e.target.value);
      setInitiatorEmailError("Please enter valid email id");
    }
  }
  const validateVendorEmail = (e) => {
    const vEmail = e.target.value;
    if (validator.isEmail(vEmail)) {
      setVendorEmail(e.target.value)
      setVendorEmailError("");
    } else {
      setVendorEmail(e.target.value)
      setVendorEmailError("Please enter valid email id");
    }
  }
  const validateVendorEmailCc = (e) => {
    const vEmail = e.target.value;
    if (validator.isEmail(vEmail)) {
      setVendorEmailCc(e.target.value)
      setVendorEmailCcError("");
    } else {
      setVendorEmailCc(e.target.value)
      setVendorEmailCcError("Please enter valid email id");
    }
  }

  if (auth && auth.userData) {
    return (

      <form onSubmit={handleSubmit}>

        <div class="container">
          <div class="row">
            <div class="col-8 p-0">
              <img src={imgLogo} alt="Logo" width="100%" height="80%" />
            </div>
            <div class="col-4 p-0">
              <img src={rightLogo} alt="Logo" width="100%" height="80%" />
            </div>
          </div>
          <div class="marginLeft" Id="InitialFields">
            <div class="row"><label style={{ color: 'red' }}>{apiErrormessage}</label> </div>
            <div class="row">
              <h6><b style={{ color: 'black' }}>PLEASE ENSURE THE FOLLOWING INFORMATION IS ACCURATE</b></h6>
            </div>
            <div class="row">
             {/* <div class="col-2">
                <label for="InitiatorEmailAddress">Initiator User ID<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={InitiatorEmailAddress}
                  onChange={(e) => setInitiatorEmailAddress(e.target.value)}
                  placeholder="Enter Initiator User ID" required />
              </div> */}
              <div class="col-2"> <label for="TicketNumber">Scrap Ticket ID<p style={{ color: "red", float: "right" }}>*</p></label></div>
              <div class="col-4">
                <input type="number" value={TicketNumber} onChange={(e) => setTicketNumber(e.target.value)} placeholder="Enter Scrap Ticket ID (Ex: XXXXXX)" required style={{ borderColor: invalidTicketID ? 'red' : '' }} />
              </div>

            </div>
            <div class="row">
              <div class="col-2">
                <label for="vendorCode">Vendor Code<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="number"
                  value={VendorCode}
                  onChange={(e) => setVendorCode(e.target.value)}
                  placeholder="Enter Vendor code" required />
              </div>
              <div class="col-2">
                <label for="vendorEmail">Vendor Email<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={VendorEmail}
                  onChange={(e) => validateVendorEmail(e)}
                  placeholder="Enter Vendor email" required />
                <div style={{ color: 'red' }}>{vendorEmailError}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label for="vendorEmail(cc)">Vendor Email (cc)</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={VendorEmailCc}
                  onChange={(e) => validateVendorEmailCc(e)}
                  placeholder="Enter Vendor email (Cc)" />
                <div style={{ color: 'red' }}>{vendorEmailCcError}</div>
              </div>
            </div>

          </div>


          <div>
            <div className="row">
              <div className="col-12"><h5 className="generalInfoStyle">How were the part(s) mutilated? <label style={{ color: 'red' }}>*</label></h5></div>
            </div>
            <div className="row">

              {
                checkboxes.map(item => (
                  <div>
                    <label key={item.key}>
                      <input type="checkbox" name={item.name} checked={checkedItems[item.name]} onChange={handleChange} />
                      &nbsp;{item.name}
                    </label><br /><n />
                  </div>
                ))
              }
            </div>
            {showOtherCommentsText ? <div className="row">
              <div className="col-12">
                <input type="text" id="OtherComments" value={OtherComments} onChange={(e) => setOtherComments(e.target.value)} placeholder="" required={showOtherCommentsText} />
              </div></div> : ""}

          </div>
          
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Mutilation Witness <label style={{ color: 'red' }}>*</label></h5></div></div>
          <div class="row">
            {/* <div class="col-2">
              <label for="Coments">Mutilation Witness<label style={{ color: 'red' }}>*</label></label>
            </div> */}
            <div class="col-12">
              <textarea class="VendorComments" id="Comments" name="Comments" value={comments} placeholder="Enter the Quality Manager or DQR name that witnessed the mutilation." onChange={(e) => setComments(e.target.value)} required></textarea>
            </div>
          </div>

          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Attachments</h5></div></div>
          <div class="marginLeft" Id="attachments">
          <div class="row"> <div class="GeneralInfoNote"><b>You may include pictures of your scrapped parts or a scrap certificate</b></div></div>
          <div class="row">
            {/* <div class="col-7">
              <label for="subject">Attachments ()</label>
            </div> */}
            <div class="col-5">
              <input type="file" onChange={(e) => setSelectedFile(e.target.files ? e.target.files : null)} multiple />
            </div>
          </div>
          </div>
          <br/>

          <div class="row">
            <div>
              <input type="checkbox" value={isConfirmChecked} onChange={handleChangeConfirmCheckbox} required />&nbsp;&nbsp; <label style={{ color: 'red' }}>I confirm this form and attached document(s) DO NOT contain any technical information subject to EAR, ITAR or ECL</label>
            </div>
          </div>


          <div class="row">
            <div class="col-4">
              <input type="submit" value="Confirm Mutilation" /> &nbsp;
              <input type="button" value="Home" onClick={onClickHomeHandler} /> &nbsp;
              <input type="button" value="Cancel" onClick={onClickCancelHandler} />
            </div>
          </div>
          <div class="row">
            <div class="col-10 text-success">
              <Modal
                show={modelPopupshow}
                onHide={handleOkButtonModelPopup}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                  <Modal.Title> Scrap Evaluation</Modal.Title>
                </Modal.Header>
                {/* <Modal.Body>
        <p>Your Mutilation Confirmation update request has been submitted successfully.</p>       
        <p>Please reach out to Scrap Evaluation Admins (scrap.admins@prattwhitney.com) in case of any issues or concerns regarding your request. </p>
        <p>You will be redirected to the home page in 10 seconds automatically. Click OK to go to home page now.</p>
        </Modal.Body> */}
                <Modal.Body>
                  <p> Your Mutilation Confirmation update request has been submitted.</p>                  
                  <p> Please reach out to your buyer in case of any issues or concerns regarding your request.</p>
                  <p> Click <strong><mark>OK</mark></strong> to return to the home page</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleOkButtonModelPopup}>
                    OK
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={loading}
                onHide={handleOkButtonModelPopup}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                  <Modal.Title> Request in-progress, please wait...</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>Loading....</p>
                </Modal.Body>
              </Modal>

              {apimessage}
            </div>
          </div>
        </div>
      </form>
    )
  } else {
    return <div>Not logged in! Try to refresh to be redirected to login page.</div>;
  }
}

export default ConfirmMutilation;
